import { render, staticRenderFns } from "./eulogyItem.vue?vue&type=template&id=372c0cea&scoped=true"
import script from "./eulogyItem.vue?vue&type=script&lang=js"
export * from "./eulogyItem.vue?vue&type=script&lang=js"
import style0 from "./eulogyItem.vue?vue&type=style&index=0&id=372c0cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c0cea",
  null
  
)

export default component.exports